import { useOutletContext } from 'react-router-dom';

import AICodingBuilder from './AICodingBuilder';
import SidebarNavAnalytics from './SidebarNavAnalytics';
import { SurveyLaunchedContext } from './SurveyLaunchedPage';
import SurveyWithSidebar from '../layout/SurveyWithSidebar';
import ExportPageNavigation from './ExportPageNavigation';

export const AICoding = () => {
  const { questions, survey, surveyId, waves } =
    useOutletContext<SurveyLaunchedContext>();

  return (
    <SurveyWithSidebar sidebarNav={<SidebarNavAnalytics surveyId={surveyId} />}>
      <ExportPageNavigation currentPage="ai-coding" surveyId={surveyId} />
      {survey && <AICodingBuilder questions={questions} waves={waves} />}
    </SurveyWithSidebar>
  );
};
